import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import MuiLink from "@mui/material/Link";
import Divider from "@mui/material/Divider";
import { Link } from "react-router-dom";
import Confirm from "../Confirm";
import EventStore from "../../stores/eventStore";
import { getEventData, deleteEvent } from "../../api/event";
import { updateEvent } from "../../api/event";
import moment from "moment";

const CustomToolbar = () => {
  return (
    <GridToolbarContainer>
      <GridToolbarExport
        printOptions={{ disableToolbarButton: true }}
        csvOptions={{
          fileName: "export",
          utf8WithBom: true,
        }}
      />
    </GridToolbarContainer>
  );
};

const TbRactType = ({ data, saveDel }) => {
  const { events, setEvents } = EventStore();
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  ///////
  const columns = [
    { field: "ractTypeName", headerName: "ประเภทการแข่งขัน(TH)", width: 500 },
    { field: "ractTypeNameEn", headerName: "ประเภทการแข่งขัน(EN)", width: 500 },

    {
      field: "action",
      width: 150,
      headerName: "แก้ไข/ลบ",
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      disableExport: true,
      renderCell: (params) => {
        const del = async (id) => {
          //let d = await deleteEvent(id);
          //getEventData(setEvents);
          setDeleteId(id);
          setOpen(true);
        };
        return (
          <Stack direction="row" spacing={1}>
            <Tooltip title={"แก้ไข"}>
              <MuiLink
                component={Link}
                to={`/ract-type/${params.row.ractTypeId}/edit`}
              >
                <BorderColorIcon fontSize="small" />
              </MuiLink>
            </Tooltip>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Tooltip title="ลบ">
              <MuiLink
                component={Link}
                to={"#"}
                onClick={() => del(params.row.ractTypeId)}
              >
                <DeleteIcon fontSize="small" />
              </MuiLink>
            </Tooltip>
          </Stack>
        );
      },
    },
  ];
  //////
  const confirmDelete = async (id) => {
    await saveDel(id);
    setOpen(false);
  };

  const onOff = async (id, status) => {
    let on = "N";
    if (status === true) {
      on = "Y";
    }
    await updateEvent(id, { eventOpen: on });
  };

  return (
    <div style={{ width: "100%" }}>
      <DataGrid
        getRowId={(row) => row.ractTypeId}
        autoHeight
        rows={data}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
        disableSelectionOnClick
        components={{
          Toolbar: CustomToolbar,
        }}
      />
      <Confirm
        title={"ลบข้อมูล"}
        desc="ยืนยันการลบข้อมูล"
        open={open}
        setOpen={setOpen}
        id={deleteId}
        confirmDelete={confirmDelete}
      />
    </div>
  );
};

export default TbRactType;
